import React from 'react';
import './PrivacyPage.scss'; // Import the SCSS file
import LogoImg from "../../../assets/images/smallLogo.svg";

const PrivacyPage = () => {
  return (
    <div className="privacy-page-container">
        <div className="privacy-center">
         <img
                  src={LogoImg}
                  alt="Logo"
                  className="logo"
                  height={150}
                  width={150}
                />
              
      <h1 className="page-title">Privacy Policy</h1>
      <p className="last-updated">Last Updated: March 2025</p>

      </div>

      <p>
        Welcome to <strong>Cultivate</strong>. This Privacy Policy explains how we
        collect, use, disclose, and safeguard your information when you visit our
        website <a href="https://cultivateapp.ai" target="_blank" rel="noopener noreferrer" className="contact-link">cultivateapp.ai</a>.
      </p>

      <h2 className="section-title">1. Information We Collect</h2>
      <p>We may collect the following information:</p>
      <ul className="list">
        <li className="list-item"><strong>Personal Information:</strong> Name, email address, phone number.</li>
        <li className="list-item"><strong>Usage Data:</strong> IP address, browser type, operating system, access times.</li>
        <li className="list-item"><strong>Cookies & Tracking Technologies:</strong> We use cookies to enhance user experience.</li>
      </ul>

      <h2 className="section-title">2. How We Use Your Information</h2>
      <p>We use collected data for:</p>
      <ul className="info-list">
        <li className="info-list-item">Improving our services and website experience.</li>
        <li className="info-list-item">Sending promotional emails and updates.</li>
        <li className="info-list-item">Responding to inquiries and customer support requests.</li>
      </ul>

      <h2 className="section-title">3. Data Sharing & Security</h2>
      <p className="security-note">We do not sell your data to third parties.</p>
      <p className="security-note">Data is securely stored and protected.</p>

      <h2 className="section-title">4. Your Rights</h2>
      <p>You have the following rights regarding your data:</p>
      <ul className="info-list">
        <li className="info-list-item">You can request access to your data.</li>
        <li className="info-list-item">You can request modification of your data.</li>
        <li className="info-list-item">You can request deletion of your data at any time.</li>
      </ul>

      <h2 className="section-title">5. Contact Us</h2>
      <p>
        For any concerns or questions regarding this Privacy Policy, please contact us at{' '}
        <a href="mailto:support@cultivateapp.ai" className="contact-link">support@cultivateapp.ai</a>.
      </p>
    </div>
  );
};

export default PrivacyPage;